export enum MaterialTab {
    Material = "material",
    Assembly = "assembly",
    Product = "product"
}

export type MaterialTabType = `${MaterialTab}`;

export const MaterialTabList: MaterialTabType[] = [
    MaterialTab.Material,
    MaterialTab.Assembly,
    MaterialTab.Product
];

export const MaterialTabIndexMap: Record<MaterialTabType, number> =
    Object.fromEntries(MaterialTabList.map((name, index) => [name, index])) as Record<
        MaterialTabType,
        number
    >;
